import { useContext } from 'react';
import { ScheduleContext } from '../../Providers/Schedule/Schedule.tsx';

export function useScheduleState() {
  return useContext(ScheduleContext);
}
